import * as FIELD_NAME from 'constant/form-item-names'
import * as FIELD_LABEL from 'constant/form-labels'
import * as RULES from 'constant/form-rules'
import * as NUMBER from 'constant/number'
import React from 'react'
import { Form, Input } from 'antd'
import PropTypes from 'prop-types'
import styles from '../styles.scss'

const EmailInput = ({ disabled = false }) => {
  return (
    <>
      <span>{FIELD_LABEL.EMAIL}</span>
      <Form.Item
        name={FIELD_NAME.EMAIL}
        rules={[RULES.REQUIRED, RULES.maxCharLength(NUMBER.TWO_FOUR_ZERO)]}
      >
        <Input
          className={styles.form_input}
          disabled={disabled}
          placeholder={'Email'}
        />
      </Form.Item>
    </>
  )
}

EmailInput.propTypes = {
  disabled: PropTypes.bool
}
export default EmailInput
